import React, { useState } from 'react';
import VehicleMap from '../components/VehicleMap';
import InfoPanel from '../components/InfoPanel';
import StoreBanner from '../components/StoreBanner';
import ProductRecommendations from '../components/ProductRecommendations';

interface HomePageProps {
  onTabChange: (tab: string) => void;
}

const HomePage: React.FC<HomePageProps> = ({ onTabChange }) => {
  const [activeTab, setActiveTab] = useState<'my' | 'all'>('my');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Section 1: 车辆地图 */}
      <div className="bg-white mb-6">
        <div className="p-6">
          <div className="flex border-b border-gray-200">
            <button
              onClick={() => setActiveTab('my')}
              className={`px-6 py-3 font-medium text-base ${
                activeTab === 'my'
                  ? 'text-primary border-b-2 border-primary'
                  : 'text-gray-500'
              }`}
            >
              我的车辆
            </button>
            <button
              onClick={() => setActiveTab('all')}
              className={`px-6 py-3 font-medium text-base ${
                activeTab === 'all'
                  ? 'text-primary border-b-2 border-primary'
                  : 'text-gray-500'
              }`}
            >
              全部车辆
            </button>
          </div>
        </div>
        
        <VehicleMap activeTab={activeTab} />
        
        <div className="p-4">
          <button 
            onClick={() => onTabChange('vehicle')}
            className="w-full bg-primary text-white py-4 rounded-xl font-medium text-lg hover:bg-blue-600 transition-colors"
          >
            立即用车
          </button>
        </div>
        
      </div>

      {/* Section 2: 信息面板 */}
      <InfoPanel />

      {/* Section 3: 商店横幅 */}
      {/* <StoreBanner /> */}

      {/* Section 4: 推荐产品 */}
      <ProductRecommendations />
    </div>
  );
};

export default HomePage;
